import { IUserCredentials } from "core/interfaces/user-credentials.interface";

export type IResetPasswordCredentials = Pick<IUserCredentials, "email">;

export const defaultResetPasswordValues: IResetPasswordCredentials = {
    email: "",
}
